import { useEffect, useRef, useState } from "react";
import { Map, } from '@pbe/react-yandex-maps';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";
import RenderPlacemarkBusStations from "../Placemarks/stations/RenderPlacemarkBusStations";
import { IBusStation } from "@/shared/types/busStaition";
import TransportOnRoadmap from "../Placemarks/transport/TransportOnRoadmap";
import { setZoomMap } from "../../store/mapScreenSlce";
import RenderRoadmapPolilines from "../Polylines/RenderPolilinesRoadmaps";
import RenderPacemrkAllTransports from "../Placemarks/transport/RenderPacemrkAllTransports";
import { calculateBounds } from "../../utils/map";

const YMap = () => {
    const { busStations, center, zoom, bounds, viewPortMode } = useSelector((state: RootState) => state.mapScreen);
    const [mapCenter, setCenter] = useState<number[]>(center);
    const [ymapsApi, setYmapsApi] = useState<any>(null);
    const mapRef = useRef<any>(null); // Ссылка на экземпляр карты
    const dispatch = useDispatch();

    const moveMap = () => {
    };

    useEffect(() => {
        if (viewPortMode === 'centerChange' && center) {
            moveMap();
        }
        if (viewPortMode === 'bounds' && bounds && bounds.options && bounds.values && mapRef.current) {
            mapRef.current.setBounds(bounds.values, bounds.options);
        }
    }, [center, bounds, viewPortMode])

    function onMapLoad(ymaps: any) {
        console.log("Yandex Maps API loaded");
        setYmapsApi(ymaps); // Сохраняем API для дальнейшего использования
    }

    return (
        <Map
            className="map-screen__map"
            state={{
                center: center,
                zoom: zoom,
            }}
            onBoundsChange={(e: any) => {
                const zoom = e.get('newZoom');
                if (zoom) {
                    dispatch(setZoomMap(zoom))
                }
            
            }}
            instanceRef={(ref) => {
                if (ref) mapRef.current = ref;
            }}
            onLoad={onMapLoad}
        >
            <RenderPlacemarkBusStations />
            <RenderRoadmapPolilines />
            {/* <TransportOnRoadmap /> */}
            <RenderPacemrkAllTransports ymapsApi={ymapsApi} />
        </Map>
    )
}

export default YMap;